export default "__VITE_ASSET__C6wlG$Bn__"